import { render, staticRenderFns } from "./LyghtRevenueAccounts.vue?vue&type=template&id=4be848b4&scoped=true&"
import script from "./LyghtRevenueAccounts.vue?vue&type=script&lang=js&"
export * from "./LyghtRevenueAccounts.vue?vue&type=script&lang=js&"
import style0 from "./LyghtRevenueAccounts.vue?vue&type=style&index=0&id=4be848b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be848b4",
  null
  
)

export default component.exports